function isParent(refNode: Node, otherNode: Node): boolean {
    let parent: Node | null = otherNode.parentNode;

    while (parent) {
        if (parent === refNode) {
            return true;
        }

        parent = parent.parentNode;
    }

    return false;
}

// ----------------------------------------------------------------------------

export default isParent;
